export default __webpack_public_path__ + "static/media/Project03.7448b7a3.jpg";